import * as localforage from 'localforage';
import { AssetReport, UpdateAssetReportRequest } from '../type/AssetReport.type';
import { v4 as uuidv4 } from 'uuid';
import { useAppStateLoadingCountStore } from '../../../common/store/AppStateStore.zustand';
import axios from 'axios';
import { SERVER_URL } from '../../../common/comstant/CommonConstants';

export const assetReportStore = localforage.createInstance({
  name: 'honeymoonsalad',
  storeName: 'assetReportStore',
});

export const useAssetReportStore = () => {
  const { addCount, minusCount } = useAppStateLoadingCountStore();

  const exportAssetReportStore = async () => {
    if (!assetReportStore) return;

    const keys = await assetReportStore.keys();
    const entries = await Promise.all(keys.map(async (key) => ({ key, value: await assetReportStore.getItem(key) })));
    return entries;
    // const { data } = await axios.get<AssetReport[]>(`${SERVER_URL}/asset-report`);
    // return data.map((assetReport) => ({ key: assetReport.id, value: assetReport }));
  };

  const importAssetReportStore = async (entries: { key: string; value: unknown }[]) => {
    if (!assetReportStore) return;

    await assetReportStore.clear();
    await Promise.all(entries.map(({ key, value }) => assetReportStore.setItem(key, value)));
    return true;
  };

  const clearAssetReportStore = async () => {
    if (!assetReportStore) return;

    await assetReportStore.clear();
    return true;
  };

  const insertAssetReportToStore = async (assetReport: AssetReport) => {
    if (!assetReportStore) return { data: '' };
    addCount();

    const assetReportId = uuidv4().toString();
    assetReport.id = assetReportId;
    assetReport.reportItemList.forEach((item) => {
      item.id = uuidv4();
      item.assetReportId = assetReportId;
    });
    await assetReportStore.setItem(assetReportId, assetReport);

    minusCount();
    return { data: assetReportId };
  };

  const getAssetReportListFromStore = async () => {
    if (!assetReportStore) return { data: [] };
    addCount();

    const keys = await assetReportStore.keys();
    const assetReportList = (await Promise.all(
      keys.map((key) => assetReportStore.getItem<AssetReport>(key)),
    )) as AssetReport[];

    minusCount();
    return { data: assetReportList.map(assetReport => ({...assetReport, reportItemList: assetReport.reportItemList.map(reportItem => ({...reportItem, amount: Number(reportItem.amount)}))})).sort((a, b) => -a.yearMonth.localeCompare(b.yearMonth)) };
  };

  const updateAssetReportAtStore = async (id: string, updateAssetReportRequest: UpdateAssetReportRequest) => {
    if (!assetReportStore) return { data: '' };
    addCount();

    updateAssetReportRequest.reportItemList.forEach((item) => {
      if (!item.id) {
        item.id = uuidv4();
        item.assetReportId = id;
      }
    });
    const assetReport = await assetReportStore.getItem<AssetReport>(id);
    if (!assetReport) return { data: '' };
    await assetReportStore.setItem(id, {
      ...assetReport,
      yearMonth: updateAssetReportRequest.yearMonth,
      reportItemList: updateAssetReportRequest.reportItemList,
    });

    minusCount();
    return { data: id };
  };

  const deleteAssetReportAtStore = async (id: string) => {
    if (!assetReportStore) return { data: null };
    addCount();

    const assetReport = await assetReportStore.getItem<AssetReport>(id);
    await assetReportStore.removeItem(id);

    minusCount();
    return { data: assetReport };
  };

  return {
    assetReportStore,
    exportAssetReportStore,
    importAssetReportStore,
    clearAssetReportStore,
    insertAssetReportToStore,
    getAssetReportListFromStore,
    updateAssetReportAtStore,
    deleteAssetReportAtStore,
  };
};
